import React from 'react'

import { createCanonicalPdpUrl } from '../../../../app/_components/navigation/createPdpUrl'
import { SeoMeta } from '../../../../components/SeoMeta'

import { usePdpDeprecatedServerSideProps } from './PdpDeprecatedServerSidePropsProvider'
import { usePdpServerSideProps } from './PdpServerSidePropsProvider'

const ProductPageMeta = ({ handle: handleProp }: { handle: string }) => {
  const { data: pdpServerSideProps } = usePdpServerSideProps()
  const { handle } = pdpServerSideProps?.product ?? {}
  const { seoTitle, color, exclusive, gender, noSearchIndex, seoDescription, description, images } =
    pdpServerSideProps?.product.variantGroup ?? {}
  const colorName = color?.displayValue
  const image = images?.[0]?.url

  const pageTitle: string | undefined = (() => {
    if (!seoTitle || !colorName) return
    return `${seoTitle} - ${colorName}`
  })()

  const canonicalUrl = createCanonicalPdpUrl({
    productGroupHandle: handle ?? handleProp,
    isKit: false,
    isExclusive: exclusive,
    genderKey: gender,
  })

  const { data: pdpDeprecatedServerSideProps } = usePdpDeprecatedServerSideProps()
  const { videos } = pdpDeprecatedServerSideProps?.productGroup?.featuredProduct ?? {}
  const video = videos?.nodes[0]?.source

  return (
    <SeoMeta
      canonicalUrl={canonicalUrl}
      image={image}
      noindex={noSearchIndex}
      video={video}
      description={seoDescription ?? undefined}
      imageAlt={description ?? undefined}
      title={pageTitle}
    />
  )
}

export default ProductPageMeta
